(() => {
 if(customElements.get('dunya-accent-hero-video'))return;
 class HeroVideo extends HTMLElement {
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();const signal=this.abort.signal;
   const video=this.querySelector('video'),button=this.querySelector('button');if(!video||!button)return;
   this.video=video;video.muted=true;video.defaultMuted=true;video.playsInline=true;video.loop=true;
   const motion=matchMedia('(prefers-reduced-motion: reduce)');
   const sync=()=>{button.textContent=video.paused?'Play background video':'Pause background video';};
   const play=()=>{const result=video.play();if(result?.catch)result.catch(sync);};
   button.hidden=false;sync();
   video.addEventListener('play',sync,{signal});video.addEventListener('pause',sync,{signal});
   video.addEventListener('error',()=>{button.hidden=true;},{signal});
   button.addEventListener('click',()=>{if(video.paused)play();else video.pause();},{signal});
   motion.addEventListener('change',()=>{if(motion.matches){video.autoplay=false;video.pause();}},{signal});
   document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();},{signal});
   if(motion.matches){video.autoplay=false;video.pause();}else play();
  }
  disconnectedCallback(){this.video?.pause();this.abort?.abort();this.abort=null;}
 }
 customElements.define('dunya-accent-hero-video',HeroVideo);
})();
